import React from "react"
import { graphql } from "gatsby"
import styled from "styled-components"
import Layout from "../components/layout"
import SEO from "../components/seo"
import PostCard from "../components/PostCard"
import CategoryMenu from "../components/CategoryMenu"

const CategoryPostList = styled.div`
  margin: 0 0 100px 0;
`

class CategoryTemplate extends React.Component {
  render() {
    const { data, pageContext } = this.props
    const posts = data.allMarkdownRemark.edges
    // const { location } = this.props
    // get Category name from category slug
    const categoryName = pageContext.category

    return (
      <Layout location={this.props.location} title={categoryName}>
        <CategoryMenu />
        <SEO title={categoryName} />
        <CategoryPostList>
          {posts.map(({ node }) => {
            return <PostCard key={node.fields.slug} node={node} />
          })}
        </CategoryPostList>
      </Layout>
    )
  }
}

export default CategoryTemplate

export const pageQuery = graphql`
  query BlogPostsByCategory($category: String) {
    allMarkdownRemark(
      limit: 1000
      sort: { fields: [frontmatter___date], order: DESC }
      filter: { frontmatter: { category: { eq: $category } } }
    ) {
      edges {
        node {
          fields {
            slug
          }
          frontmatter {
            date(formatString: "YYYY/MM/DD")
            title
            category
          }
        }
      }
    }
  }
`
